export default __webpack_public_path__ + "static/media/AirplaneActive.732b341c.svg";